import React from 'react'
import { getPlanColor, getPlanDotColor } from '../../lib/utils'

interface PlanBadgeProps {
  plan: string
  size?: 'sm' | 'md'
}

const PlanBadge: React.FC<PlanBadgeProps> = ({ plan, size = 'md' }) => {
  const colorClass = getPlanColor(plan)
  const dotColor = getPlanDotColor(plan)
  const sizeClass = size === 'sm' ? 'px-1.5 py-0.5 text-xs' : 'px-2.5 py-1 text-xs font-medium'

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${colorClass} ${sizeClass}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dotColor}`} />
      {plan}
    </span>
  )
}

export default PlanBadge
